<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
              <a-form-item label="基地">
              <a-select placeholder="请选择基地" v-model="queryParam.base"   @select="baseSelectSelect"  >
                  <a-select-option  v-for="item in baseOptions" :value="item.text"  :key="item.text" >{{item.text}}</a-select-option>
              </a-select>
              </a-form-item>
          </a-col> 
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
              <a-form-item label="部门">
              <a-select placeholder="请选择部门" v-model="queryParam.depart"  @select="departSelectSelect"  >
                  <a-select-option  v-for="item in departOptions" :value="item.text"  :key="item.text" >{{item.text}}</a-select-option>
              </a-select>
              </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
              <a-form-item label="区域">
              <a-select placeholder="请选择区域" v-model="queryParam.workshop">
                  <a-select-option  v-for="item in workshopOptions" :value="item.text"  :key="item.text" >{{item.text}}</a-select-option>
              </a-select>
              </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="downLoadQRCode" icon="download" style="margin-left: 8px">下载二维码</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('金牌石信息')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
      <a-button  class="button-right"   @click="searchReset" type="primary" icon="plus">刷新</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey=""
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此图片</span>
          <img v-else :src="getImgView(record)" height="25px" alt="图片不存在" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="openSelectUser(record)">修改负责人</a>
          <a-divider type="vertical" />
          <a @click="getImgView(record)">二维码</a>
        </span>

      </a-table>
    </div>
    <select-user-modal ref="selectUserModal"  :onlySelectOne="true"  @selectChoosed="selectOK"></select-user-modal>
    <a-modal
      title="二维码"
      :visible="showQrcodeModal"
      width="1000px"
      @cancel="closeQrcodeModal"
      @ok="closeQrcodeModal"
    >
      <div  class="img-qrcode-flex"  >
        <img v-for="(item,index) in qrcodeImgArr" :src="item" :key="index"  alt="图片不存在" />
      </div>
    </a-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SelectUserModal from './modules/SelectUserModal'
  import {  putAction,postAction,downFile  } from '@/api/manage'
  import QRCode from 'qrcodejs2'
  import html2canvas from 'html2canvas';
  import {  getRealHeight} from "../../utils/dom.js"
  import moment from 'moment'

  export default {
    name: "ConfigurationWorkshop",
    mixins:[JeecgListMixin],
    components: {
      SelectUserModal
    },
    data () {
      return {
        qrCodeImgUrl:"",
        qrCodeImgUrl2:"",
        baseOptions:[],
        departOptions:[],
        workshopOptions:[],
        showQrcodeModal:false,
        qrcodeImgArr:[],
        description: '金牌石信息管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'基地',
            align:"center",
            dataIndex: 'base'
          },
          {
            title:'部门',
            align:"center",
            dataIndex: 'depart'
          },
          {
            title:'区域',
            align:"center",
            dataIndex: 'workshop'
          },
          {
            title:'负责人',
            align:"center",
            dataIndex: 'userName'
          },
           {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' }
          },
        ],
        url: {
          list: "/general/workshop/list",
        },
        dictOptions:{},
        recordChoose:{},
      }
    },
    created() {
      postAction("/general/inspection/api/report/getBaseDepartWorkshop", {}).then((res)=>{
          if(res.code==200){
              this.baseOptions=res.result
          }
      })
    },
    computed: {
    },
    methods: {
      downLoadQRCode(){
        var params = this.getQueryParams();//查询条件
        let closeLoading = this.$message.loading('生成中...', 0)
        downFile("/general/inspection/api/download/QrCode", params).then((data) => {
          if (!data) {
              this.$message.warning("文件下载失败")
              return
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
              window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-excel' }), fileName + '.xls')
          } else {
              let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url
              link.setAttribute('download',  '区域二维码('+moment().format("YYYY年MM月DD日_HH点mm分ss")+').zip')
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link); //下载完成移除元素
              window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        }).finally(()=>{
          closeLoading()
        })
      },
      initDictConfig(){
      },
      selectOK(selectData){
        console.log(selectData)
        console.log(this.recordChoose)
        if(!this.recordChoose){
          this.$message.error("找不到区域信息，请检查操作是否正确");
          return
        }
        let params=this.recordChoose;
        params.userName=selectData[0].realname
        params.userNo=selectData[0].username 
        putAction("/general /workshop/saveWorker",params).then((res)=>{
            if(res.success){
              this.$message.success(res.message);
              this.loadData();
            }else{
              this.$message.error(res.message);
            }
        })
      },
      openSelectUser(record){
        this.recordChoose=record;
        this.$refs.selectUserModal.add();
      },
      openQrCode(){
      },
      getImgView(record){
        let params={
          base:record.base,
          depart:record.depart,
          workshop:record.workshop,
        }
        let closeLoading = this.$message.loading('请求中...', 0)
        postAction("/general/inspection/api/getQrCode",params).then((res)=>{
          if(res.success){
            this.qrcodeImgArr=res.result
            this.showQrcodeModal=true
          }
        }).finally((e)=>{
          console.log(e);
          closeLoading();
        })
      },
      getUrlcode(qrcodetext) {
        var qrcodeNode = document.getElementById("qrcode-id");
        if(qrcodeNode.innerHTML){
          qrcodeNode.innerHTML = ''
        }
        var qrwith=135;
        new QRCode(this.$refs.qrCodeUrl,{
          text:qrcodetext,
          width:getRealHeight(qrwith),
          height:getRealHeight(qrwith)
        })
      },
      closeQrcodeModal(){
        this.showQrcodeModal=false
        this.qrcodeImgArr=[];
      },
      baseSelectSelect(value,options){
          this.departOptions=[];
        this.workshopOptions=[];
          this.$set(this.queryParam,"depart","")
          this.$set(this.queryParam,"workshop","")
          this.baseOptions.some((item)=>{
              if(item.text==value){
                  this.departOptions=item.children
                  return true
              }
          })
      },
      departSelectSelect(value,options){
          this.workshopOptions=[];
          this.$set(this.queryParam,"workshop","")
          this.departOptions.some((item)=>{
              if(item.text==value){
                  this.workshopOptions=item.children
                  return true
              }
          })
      },
    },
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
  .img-qrcode-flex{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .button-right{
    margin-left: auto !important;
    width: 100px;
    display:block;
  }
  .created-div{
    position: absolute;
    width: 2.56rem;
    height:3.56rem;
  }
  .backImg{
    width: 2.56rem;
    height: 3.56rem;
    position: absolute;
  }
  .logoImg{
    position: absolute;
    width: 0.3rem;
    height: 0.3rem;
    border-radius: 50%;
    z-index: 4;
    left: 1.13rem;
    top: 1.6rem;
    background-color: rgb(255,255,255);
  }
  .qrcode{
    position: absolute;
    z-index: 3;
    left: 0.64rem;
    top: 1.09rem;
  }
  .p-skcode{
    position: absolute;
    width: 100%;
    z-index: 3;
    text-align: center;
    top: 2.10rem;
    font-size: 0.01rem;
    font-weight: 600;
    color: white;
    top: 2.50rem;
    font-size: 0.1rem;
  }
  .need-img{
    width: 2.56rem;
    height: 3.56rem;
  }
  .p-saveImg{
    font-weight: 500;
    position: fixed;
    top: 3.9rem;
  }
  p{
      display: block;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      text-align: center;
      position: relative;
  }
</style>